import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';
import Title from '../shared/title';
import {formatToolList} from '../../../../shared/utils/format-tool-list';
import JobCard from '../../../../shared/library/cards/jobs/jobs-card';
import {PHONE} from '../../../../shared/style/breakpoints';
import {Query} from 'react-apollo';
import {Spinner} from '../../../tool-profile/components/shared/styles';
import Circular, {LARGE} from '../../../../shared/library/indicators/indeterminate/circular';
import {stackupJobs} from '../../../../data/stackups/queries';
import {Link} from '../../../../shared/library/cards/card';
import {StackupsLinks} from '../shared/styles';

const JobsContainer = glamorous.div({
  margin: '20px 0',
  display: 'grid',
  gap: 15,
  gridTemplate: 'repeat(1, 1fr) / repeat(2, 1fr)',
  [PHONE]: {
    gridTemplate: 'repeat(1, 1fr) / repeat(1, 1fr)',
    gap: '15px 0',
    padding: '0 15px'
  }
});

const Jobs = ({tools, slug}) => {
  return (
    <Query query={stackupJobs} variables={{slug: slug}}>
      {({loading, data}) => {
        const hasData = data && data.stackupBySlug;
        if (loading && !hasData)
          return (
            <Spinner>
              <Circular size={LARGE} />
            </Spinner>
          );

        if (hasData) {
          const jobs = data.stackupBySlug.jobs.edges;
          return (
            <>
              <Title copy={`Jobs that mention ${formatToolList(tools)} as a desired skillset`} />
              <JobsContainer>
                {jobs.map(j => {
                  return (
                    <JobCard
                      companyName={j.node.company.name}
                      companyLogo={j.node.company.imageUrl}
                      key={j.node.id}
                      id={j.node.id}
                      url={j.node.angellistJobUrl}
                      title={j.node.title}
                      location={j.node.location}
                      services={j.node.services}
                      path={j.node.company.path}
                      isPrivate={j.node.private}
                    />
                  );
                })}
              </JobsContainer>
              <StackupsLinks>
                {tools &&
                  tools.map(({name, path}, index) => (
                    <div key={index}>
                      {jobs.length && (
                        <Link
                          data-testid="seeJobsForLink"
                          href={`/jobs${path}`}
                          title={`${name} jobs`}
                        >{`See jobs for ${name}`}</Link>
                      )}
                    </div>
                  ))}
              </StackupsLinks>
            </>
          );
        } else {
          return null;
        }
      }}
    </Query>
  );
};

Jobs.propTypes = {
  tools: PropTypes.array,
  slug: PropTypes.string
};

export default Jobs;
